export default __webpack_public_path__ + "static/media/valertLogo.4f8fb2a8.png";